<script>
  import Stack from "../layout/Stack.svelte";

  export let value

  export let options = []

  /**
   * If true, disable all options
   * @type {boolean}
   */
  export let disabled = false

  export let name
</script>

<Stack direction="vertical" gap=".5rem">
  {#each options as option}
    <label class="option-container" class:checked={value === option.value}>
      <input
        type="radio"
        bind:group={value}
        disabled={disabled || !!option.disabled}
        checked={option.value === value}
        value={option.value}
        name={name}
      />
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="#CCCCCC"/>
        {#if option.value === value}
          <circle cx="12" cy="12" r="6.5" fill="#00468F"/>
        {/if}
      </svg>
      <slot option={option}/>
    </label>
  {/each}
</Stack>

<style>
  input {
    display: none;
  }

  label {
    cursor: pointer;
  }

  .option-container {
    border: 1px solid darkgrey;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
    gap: .5rem;
  }

  .checked {
    border-color: #00468F;
  }
</style>